import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { Card } from "@/components/ui/card";
import {
  Table,
  TableHeader,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { ClipboardList } from "lucide-react";
import { api } from "@/lib/api";
import { TID } from "@/constants/testIds";
import { formatDate, STATUS_LABEL } from "@/lib/format";

export default function AdminSubscriptions() {
  const [items, setItems] = useState([]);
  const [companies, setCompanies] = useState({});
  const [plans, setPlans] = useState({});

  useEffect(() => {
    Promise.all([
      api.get("/admin/subscriptions"),
      api.get("/admin/companies"),
      api.get("/admin/plans"),
    ])
      .then(([s, c, p]) => {
        setItems(s.data);
        setCompanies(Object.fromEntries(c.data.map((x) => [x.id, x])));
        setPlans(Object.fromEntries(p.data.map((x) => [x.id, x])));
      })
      .catch(() => {});
  }, []);

  const statusTone = (s) => {
    if (s === "active") return "bg-emerald-100 text-emerald-800 border-emerald-200";
    if (s === "trial") return "bg-amber-100 text-amber-800 border-amber-200";
    if (s === "cancelled" || s === "expired") return "bg-rose-100 text-rose-800 border-rose-200";
    return "bg-stone-100 text-stone-700";
  };

  return (
    <Layout title="Assinaturas" subtitle="Todas as assinaturas das empresas">
      <Card data-testid={TID.adminSubscriptions} className="rounded-xl border-stone-200 bg-white overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="bg-stone-50">
              <TableHead className="font-body">Empresa</TableHead>
              <TableHead className="font-body">Plano</TableHead>
              <TableHead className="font-body">Ciclo</TableHead>
              <TableHead className="font-body">Status</TableHead>
              <TableHead className="font-body">Início</TableHead>
              <TableHead className="font-body">Renovação</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} className="text-center text-stone-500 py-10">
                  <ClipboardList className="h-6 w-6 mx-auto mb-2 text-stone-400" />
                  Nenhuma assinatura
                </TableCell>
              </TableRow>
            )}
            {items.map((s) => (
              <TableRow key={s.id}>
                <TableCell className="font-display font-semibold">
                  {companies[s.company_id]?.trade_name || s.company_id}
                </TableCell>
                <TableCell className="font-body text-sm">{plans[s.plan_id]?.name || "—"}</TableCell>
                <TableCell className="font-body text-sm capitalize">{s.billing_cycle}</TableCell>
                <TableCell>
                  <Badge variant="outline" className={statusTone(s.status)}>
                    {STATUS_LABEL[s.status] || s.status}
                  </Badge>
                </TableCell>
                <TableCell className="font-body text-sm">{formatDate(s.started_at)}</TableCell>
                <TableCell className="font-body text-sm">{formatDate(s.renews_at)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </Layout>
  );
}
